// @flow
import { Fragment } from 'react';
import Carousel from '../ImageAndText';

import LinkPopup from '@components/popups/Link';

import * as CrystalContent from '../../popups/content/Crystal';
import * as PinpointContent from '../../popups/content/Pinpoint';
import * as CloudContent from '../../popups/content/Cloud';
import * as CavityContent from '../../popups/content/Cavity';
import * as ChipContent from '../../popups/content/Chip';
import * as BruiseContent from '../../popups/content/Bruise';
import * as FeatherContent from '../../popups/content/Feather';
import * as NeedleContent from '../../popups/content/Needle';
import * as TwinningWispContent from '../../popups/content/TwinningWisp';
import * as NaturalContent from '../../popups/content/Natural';

const bruise = '/images/clarity_carousel/bruise.gif';
const cavity = '/images/clarity_carousel/cavity.gif';
const chip = '/images/clarity_carousel/chip.gif';
const cloud = '/images/clarity_carousel/cloud.gif';
const crystal = '/images/clarity_carousel/crystal.gif';
const feather = '/images/clarity_carousel/feather.gif';
const natural = '/images/clarity_carousel/natural.gif';
const needle = '/images/clarity_carousel/needle.gif';
const pinpoint = '/images/clarity_carousel/pinpoint.gif';
const twinningWisp = '/images/clarity_carousel/twinning_wisp.gif';

const items = (setPopupContent) => {
  return [
    {
      headerText: 'Crystal',
      component: (
        <Fragment key="Crystal">
          A single (or grouping of) mineral deposits, often black. (
          <LinkPopup initialContent={CrystalContent}>learn more</LinkPopup>)
        </Fragment>
      ),
      imageUrl: crystal,
      imageLocation: 'top',
      imageAlt: '',
      imageStyles: {
        marginTop: 20
      }
    },
    {
      headerText: 'Pinpoint',
      component: (
        <Fragment key="Pinpoint">
          A very small crystal, often whitish in color. (
          <LinkPopup initialContent={PinpointContent}>learn more</LinkPopup>)
        </Fragment>
      ),
      imageUrl: pinpoint,
      imageLocation: 'top',
      imageAlt: '',
      imageStyles: {
        marginTop: 20
      }
    },
    {
      headerText: 'Cloud',
      component: (
        <Fragment key="Cloud">
          A concentrated grouping of pinpoint inclusions. (
          <LinkPopup initialContent={CloudContent}>learn more</LinkPopup>)
        </Fragment>
      ),
      imageUrl: cloud,
      imageLocation: 'top',
      imageAlt: '',
      imageStyles: {
        marginTop: 20
      }
    },
    {
      headerText: 'Cavity',
      component: (
        <Fragment key="Cavity">
          A depression in the otherwise smooth surface. (
          <LinkPopup initialContent={CavityContent}>learn more</LinkPopup>)
        </Fragment>
      ),
      imageUrl: cavity,
      imageLocation: 'top',
      imageAlt: '',
      imageStyles: {
        marginTop: 20
      }
    },
    {
      headerText: 'Chip',
      component: (
        <Fragment key="Chip">
          A shallow surface nick, often created during cutting. (
          <LinkPopup initialContent={ChipContent}>more</LinkPopup>)
        </Fragment>
      ),
      imageUrl: chip,
      imageLocation: 'top',
      imageAlt: '',
      imageStyles: {
        marginTop: 20
      }
    },
    {
      headerText: 'Bruise',
      component: (
        <Fragment key="Bruise">
          A surface chip, often with root-like feathers radiating out. (
          <LinkPopup initialContent={BruiseContent}>more</LinkPopup>)
        </Fragment>
      ),
      imageUrl: bruise,
      imageLocation: 'top',
      imageAlt: '',
      imageStyles: {
        marginTop: 20
      }
    },
    {
      headerText: 'Feather',
      component: (
        <Fragment key="Feather">
          A fracture, often whitish, with fine radiating extensions. (
          <LinkPopup initialContent={FeatherContent}>learn more</LinkPopup>)
        </Fragment>
      ),
      imageUrl: feather,
      imageLocation: 'top',
      imageAlt: '',
      imageStyles: {
        marginTop: 20
      }
    },
    {
      headerText: 'Needle',
      component: (
        <Fragment key="Needle">
          Very fine inclusion; like a feather minus the radiating lines. (
          <LinkPopup initialContent={NeedleContent}>more</LinkPopup>)
        </Fragment>
      ),
      imageUrl: needle,
      imageLocation: 'top',
      imageAlt: '',
      imageStyles: {
        marginTop: 20
      }
    },
    {
      headerText: 'Twinning Wisp',
      component: (
        <Fragment key="Twinning Wisp">
          A ribbon of pinpoints formed during the crystal's growth. (
          <LinkPopup initialContent={TwinningWispContent}>more</LinkPopup>)
        </Fragment>
      ),
      imageUrl: twinningWisp,
      imageLocation: 'top',
      imageAlt: '',
      imageStyles: {
        marginTop: 20
      }
    },
    {
      headerText: 'Natural',
      component: (
        <Fragment key="Natural">
          Tiny remnants of original rough surface, often on the girdle. (
          <LinkPopup initialContent={NaturalContent}>more</LinkPopup>)
        </Fragment>
      ),
      imageUrl: natural,
      imageLocation: 'top',
      imageAlt: '',
      imageStyles: {
        marginTop: 20
      }
    }
  ];
};

const DiamondClarity = (props: Object) => {
  const { setPopupContent, ...otherProps } = props;

  return (
    <Carousel
      {...otherProps}
      items={items(setPopupContent)}
      contentStyles={{ minHeight: 260 }}
    />
  );
};

export default DiamondClarity;
